module.exports = __webpack_public_path__ + "img/ESBE_1572.4d7aa4cf.png";